import React from "react";

const AboutPage = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <h1 className="text-4xl font-semibold mb-4">About Us</h1>
      <p className="text-gray-600">
        Welcome to our CraveExpress! We are a team of food enthusiasts who love to
        share our passion for delicious and healthy food. Our goal is to provide
        you with a convenient way to explore and order your favorite meals from
        various restaurants in your area.
      </p>
      <p className="text-gray-600 mt-4">
        Our platform offers a wide range of cuisines, from local specialties to
        international delights. We carefully curate our restaurant partners to
        ensure that they meet our high-quality standards. Whether you're craving
        pizza, sushi, burgers, or salads, we've got you covered!
      </p>
      <p className="text-gray-600 mt-4">
        We are committed to providing a seamless and user-friendly experience for
        our customers. You can easily browse through our menu, customize your
        order, and securely checkout with multiple payment options. We also
        provide real-time order tracking, so you can keep track of your food from
        the moment it's prepared to when it's delivered to your doorstep.
      </p>
      <p className="text-gray-600 mt-4">
        Thank you for choosing CraveExpress for your culinary adventures. We
        hope you enjoy your meals and have a delightful experience with us. If
        you have any questions, feedback, or suggestions, please feel free to
        contact us. Bon appétit!
      </p>
    </div>
  );
};

export default AboutPage;
